












import { Component, Vue } from 'vue-property-decorator';
import EditRequirementForm from './components/editRequirementForm.vue';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';
import moment from 'moment';
import { requirementListInstance } from '@/model/RequirementListClass';

type IUpdateRequirementInfo = IRequirement.IModel.IUpdateRequirementInfo;

@Component({
  components: {
    EditRequirementForm,
  },
})
export default class UpdateRequirement extends Vue {
  private requirementListInstance = requirementListInstance;
  get requirement() {
    return this.requirementListInstance.editItem;
  }
  get updateRequirementInfo() {
    const result: IUpdateRequirementInfo = {
      title: '',
      description: '',
      issueId: '',
      projectId: '',
      projectName: '',
      urgency: 0,
      due: moment().format(),
    };
    if (this.requirement) {
      result.title = this.requirement.title;
      result.description = this.requirement.description;
      result.issueId = this.requirement.issueId;
      result.projectId = this.requirement.projectId;
      result.projectName = this.requirement.projectName;
      result.urgency = this.requirement.urgency;
      result.due = this.requirement.due;
    }
    return result;
  }
  private changeRequirement(
    updateInfo: IUpdateRequirementInfo,
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!this.requirement) {
        reject('Error');
        return;
      }
      requirementListInstance
        .requestChangeItem(this.requirement, updateInfo)
        .then((res) => {
          resolve(res);
          this.goListPage();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  private goListPage() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({ name: 'Requirement' });
  }
}
